// extracted by mini-css-extract-plugin
module.exports = {"section":"e_8W","list":"e_9W","ask":"e_-W","empty":"e_aX"};